import { MDSIcon, MDSIconColor, MDSIconKind } from "@/mds/components/icon";
import { StyledSelectedButton } from "./toggle-button.style";

interface IMDSToggleButtonClearToggleButtonProps {
  onSelectClear: () => void;
}

export const MDSToggleButtonClearToggleButton = ({
  onSelectClear,
}: IMDSToggleButtonClearToggleButtonProps) => {
  return (
    <StyledSelectedButton
      className="mds-toggle-button-clear"
      role="button"
      onClick={e => {
        e.stopPropagation();
        onSelectClear();
      }}
    >
      <MDSIcon kind={MDSIconKind.Exit} color={MDSIconColor.Emphasis} />
    </StyledSelectedButton>
  );
};
